// Misc
import React from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { connectGetters } from 'react-redux-getters'

// Selectors
import { getMe } from 'selectors/me'

// // Components
import { AppProgressActivator } from 'atoms/AppProgress'

// // Common routes
import createActionRoutes from './Actions'
import createCommonRoutes from './Common'

// // Complex routes
import GuestRoutes from './Guest'
import LoggedUserRoutes from './LoggedUser'

const mapGettersToProps = state => ({
  meGetter: getMe(state)
})

const Routes = ({ meGetter }) => (meGetter.isPending
  ? (
    <AppProgressActivator />
  )
  : (
    <Switch>
      { createActionRoutes() }
      { createCommonRoutes() }
      { meGetter.isFailed
        ? (<Route component={GuestRoutes} />)
        : (<Route component={LoggedUserRoutes} />)
      }
    </Switch>
  )
)

Routes.propTypes = {
  meGetter: PropTypes.object.isRequired,
}

export default connectGetters(mapGettersToProps)(Routes)
